import { useMemo } from 'react'

import MqttContext from './Context'
import mqttClient from './request'
import useMqttState from './useMqttState'

type MqttConnectorProps = {
  children: React.ReactNode
}

/**
 * Exposes MQTT state through context. It does not open a connection: the client connects lazily
 * on the first subscribe/publish and closes itself shortly after the last subscriber leaves.
 */
export default function MqttConnector({ children }: MqttConnectorProps) {
  const { client, connectionStatus } = useMqttState()

  const value = useMemo(
    () => ({
      client,
      clientId: mqttClient.getClientId(),
      connectionStatus
    }),
    [client, connectionStatus]
  )

  return <MqttContext.Provider value={value}>{children}</MqttContext.Provider>
}
